(() => {
  'use strict';
  const node = document.getElementById('kaartstudio-product-catalog');
  const configNode = document.getElementById('kaartstudio-test-config');
  if (!node || !configNode) return;
  const config = JSON.parse(configNode.textContent);
  const catalog = JSON.parse(node.textContent);
  const aliases = new Map();
  for (const product of catalog) {
    for (const id of product.aliases) aliases.set(String(id), product);
    aliases.set(String(product.templateId), product);
  }
  const resolve = id => aliases.get(String(id));
  const assertPurchasable = product => {
    if (!product) throw new Error(config.missingProduct);
    if (!product.purchasable) throw new Error(config.draftProduct);
  };
  window.KaartstudioProducts = Object.freeze({
    resolve,
    assertPurchasable,
    mapLine(item, format) {
      const product = resolve(item.id);
      assertPurchasable(product);
      const variant = product.variants[format];
      if (!variant) throw new Error(config.missingProduct);
      return {...item, id: Number(variant.id), properties: {
        ...item.properties,
        _bs_card_template: product.templateId,
        _bs_card_format: format,
      }};
    },
  });
})();
